import $store from 'stores';
import { MOOD_CHILL, MOOD_POWER } from 'constants/audio';

const PERIOD_SHORT = 60 * 1000;
const PERIOD_LONG = 150 * 1000;
const PERIOD_FINISH = 300 * 1000;

const TRESHOLD = 1;

const getCounts = () => {
  let short = 0;
  let long = 0;
  let finish = 0;

  const now = Date.now();
  $store.getters.history.forEach(({ timestamp }) => {
    const diff = now - timestamp;
    if (diff < PERIOD_SHORT) short++;
    else if (diff < PERIOD_LONG) long++;
    else if (diff < PERIOD_FINISH) finish++;
  });

  return {
    short,
    long,
    finish,
  };
};

const calculateMood = () => {
  const { short, long, finish } = getCounts();
  const value = (3 * short) + (2 * long) + finish;

  if (value > TRESHOLD) {
    return MOOD_POWER;
  }

  return MOOD_CHILL;
};

export default calculateMood;
